import React, { useState, useEffect } from "react";

import "../css/PopupCGCOOOftalmica.css";

import InputData from "../../components/InputData";
import InputTextArea from "../../components/InputTextArea";
import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import { post } from "../../js/post";
import { userData, selectedOptic } from "../../js/utils";

const OPTOMETRIST_DROPDOWN_ID = "popup-cgcoooft-optometrist";
const DIAGNOSTICO_TEXTAREA_ID = "popup-cgcoooft-diagnostico";

const IDIOMA_OPTIONS = [
  { id: "ES", text: "ESPAÑOL" },
  { id: "EN", text: "INGLÉS" },
  { id: "EU", text: "EUSKERA" },
  { id: "CA", text: "CATALÁN" },
  { id: "GA", text: "GALLEGO" },
  { id: "VA", text: "VALENCIANO" },
];

export default ({
  show,
  idFichaLentillas,
  agenteFicha,
  onAccept,
  onCancel,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [optometristList, setOptometristList] = useState([]);
  const [selectedOptometristId, setSelectedOptometristId] = useState(null);
  const [dniColegiado, setDniColegiado] = useState("");
  const [numColegiado, setNumColegiado] = useState("");
  const [nombreColegiado, setNombreColegiado] = useState("");
  const [apellidosColegiado, setApellidosColegiado] = useState("");
  const [nrsOptica, setNrsOptica] = useState("");
  const [dniPaciente, setDniPaciente] = useState("");
  const [selectedIdiomaId, setSelectedIdiomaId] = useState(
    IDIOMA_OPTIONS[0].id,
  );
  const [diagnostico, setDiagnostico] = useState("");
  const [especificaciones, setEspecificaciones] = useState("");
  const [generatingReceta, setGeneratingReceta] = useState(false);

  const cancel = () => {
    onCancel();
  };

  const selectOptometrist = (option) => {
    setSelectedOptometristId(option ? option.id : null);
    setDniColegiado(option ? option.dni : "");
    setNumColegiado(option ? option.numColegiado : "");
    setNombreColegiado(option ? option.nombre : "");
    setApellidosColegiado(option ? option.apellidos : "");
  };

  const getOptometrists = async () => {
    const response = await post("ListarOptometristas.php", {
      token: userData.token,
      optica: selectedOptic.id,
      completo: 1,
    });
    const list = (response || []).map((e) => ({
      id: e.id,
      text: `${e.nombre} ${e.apellidos}`.trim(),
      dni: e.dni,
      numColegiado: e.numColegiado,
      nombre: e.nombre,
      apellidos: e.apellidos,
    }));
    setOptometristList(list);

    const defaultOptometrist = list.find(
      (o) => o.text === (agenteFicha || "").toUpperCase(),
    );
    selectOptometrist(defaultOptometrist || null);
  };

  const getPopupInfo = async () => {
    const response = await post(
      "/support-extra/receta/ObtenerPopupInfoOftalmica.php",
      {
        token: userData.token,
        idOptometria: idFichaLentillas,
      },
    );
    setNrsOptica(response?.nrs || "");
    setDniPaciente(response?.dniPaciente || "");
    setDiagnostico(response?.diagnostico || "");
    setEspecificaciones(response?.especificaciones || "");
  };

  const generarReceta = async () => {
    if (dniPaciente === "") {
      createPopupQuestion(
        "El DNI del paciente no puede estar vacío.",
        () => {
          removePopupQuestion();
        },
        null,
        "Cerrar",
      );
      return;
    }

    setGeneratingReceta(true);
    const response = await post(
      "/support-extra/receta/ObtenerRecetaCGCOOOftalmica.php",
      {
        token: userData.token,
        idOptometria: idFichaLentillas,
        idOptometrista: selectedOptometristId,
        dni: dniPaciente,
        diagnostico,
        especificaciones,
        idioma: selectedIdiomaId,
      },
    );
    setGeneratingReceta(false);

    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Cerrar",
      );
    } else {
      const a = document.createElement("a");
      a.href = `data:application/pdf;base64,${response.fichero}`;
      a.download = `receta_cgcoo_oftalmica.pdf`;
      a.click();
      onAccept();
    }
  };

  useEffect(() => {
    if (show) {
      setSelectedIdiomaId(IDIOMA_OPTIONS[0].id);
      setDiagnostico("");
      setEspecificaciones("");
      getOptometrists();
      getPopupInfo();
      setTimeout(() => {
        document.querySelector("#" + DIAGNOSTICO_TEXTAREA_ID)?.focus();
      }, 0);
    }
  }, [show]);

  return show ? (
    <div className="popup-container popup-normal popup-cgcoooft">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Generar receta CGCOO Oftálmica</div>
          <img
            src="/images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={cancel}
          />
        </div>
        <div className="popup-body">
          <div className="popup-body-cgcoooft">
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">Optometrista</div>
              <Dropdown
                id={OPTOMETRIST_DROPDOWN_ID}
                tabIndex={1}
                size={0}
                optionList={optometristList}
                op={selectedOptometristId}
                onChange={selectOptometrist}
              />
            </div>
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">DNI colegiado</div>
              <div className="cgcoooft-row-content">
                <InputData
                  extra="cgcoooft-input-fixed"
                  inactive={true}
                  input={dniColegiado}
                  onChange={setDniColegiado}
                />
                <div className="cgcoooft-inline-group">
                  <div className="label cgcoooft-inline-label">
                    Nº de colegiado
                  </div>
                  <InputData
                    extra="cgcoooft-input-fixed"
                    inactive={true}
                    input={numColegiado}
                    onChange={setNumColegiado}
                  />
                </div>
              </div>
            </div>
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">
                Nombre colegiado
              </div>
              <InputData
                size={0}
                inactive={true}
                input={nombreColegiado}
                onChange={setNombreColegiado}
              />
            </div>
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">
                Apellidos colegiado
              </div>
              <InputData
                size={0}
                inactive={true}
                input={apellidosColegiado}
                onChange={setApellidosColegiado}
              />
            </div>
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">NRS óptica</div>
              <InputData
                size={0}
                inactive={true}
                input={nrsOptica}
                onChange={setNrsOptica}
              />
            </div>
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">DNI paciente</div>
              <div className="cgcoooft-row-content">
                <InputData
                  extra="cgcoooft-input-fixed"
                  tabIndex={2}
                  maxLength={9}
                  input={dniPaciente}
                  onChange={setDniPaciente}
                />
                <div className="label cgcoooft-inline-label">Idioma</div>
                <div className="cgcoooft-dropdown-fill">
                  <Dropdown
                    tabIndex={3}
                    optionList={IDIOMA_OPTIONS}
                    op={selectedIdiomaId}
                    onChange={(item) => setSelectedIdiomaId(item.id)}
                    mandatory={true}
                  />
                </div>
              </div>
            </div>
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">Diagnóstico</div>
              <InputTextArea
                id={DIAGNOSTICO_TEXTAREA_ID}
                tabIndex={4}
                size={0}
                maxLength={600}
                input={diagnostico}
                onChange={setDiagnostico}
              />
            </div>
            <div className="popup-cgcoooft-contenido-element">
              <div className="label cgcoooft-popup-label">
                Especificaciones
              </div>
              <InputTextArea
                tabIndex={5}
                size={0}
                maxLength={600}
                input={especificaciones}
                onChange={setEspecificaciones}
              />
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-row-buttons">
            <ButtonIconH
              text="Generar receta"
              disabled={generatingReceta}
              onClick={generarReceta}
            />
            <ButtonIconH text="Cancelar" onClick={cancel} />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
